import { FormattedMessage } from 'react-intl';
import { EmptyState } from 'components/EmptyState';
import { Button } from 'components/Button';

export function ConfigurationFilesEmptyState({ onUploadNow = undefined }: { onUploadNow?: () => void }) {
  return (
    <EmptyState
      testId="configuration-files-empty-state"
      titleId="profitability.cost-configurations.configFiles.emptyState.text"
      bold
      imageClassName="block w-40"
      gapClassName="gap-8"
      action={
        <Button onClick={onUploadNow} data-testid="configuration-files-upload-now">
          <FormattedMessage id="profitability.cost-configurations.configFiles.emptyState.button" />
        </Button>
      }
    />
  );
}
